import React from "react";

export const MatchInstructions = () => {
  return (
    <div className="match-instructions">
      <div className="container">
        <div className="match-instructions__copy">
          <span className="h2">&#128236;</span>
          <h2 className="match-instructions__title">
            Waiting for venues to confirm they are available
          </h2>
          <p>
            We've sent your event details to some leading venues. Here's what
            happens next:
          </p>
          <div className="match-instructions__info">
            <div className="match-instructions__bullet">
              <span className="match-instructions__bullet__number p">1</span>
              <p className="match-instructions__bullet__copy">
                Venues will let us know if they are available to host your event
              </p>
            </div>
            <div className="match-instructions__bullet">
              <span className="match-instructions__bullet__number p">2</span>
              <p className="match-instructions__bullet__copy">
                Details of available venues will appear on this screen, and you
                can browse images and compare prices to find the best ones
              </p>
            </div>
            <div className="match-instructions__bullet">
              <span className="match-instructions__bullet__number p">3</span>
              <p className="match-instructions__bullet__copy">
                You can contact any venues you're interested in via our
                messaging service
              </p>
            </div>
            <div className="match-instructions__bullet">
              <span className="match-instructions__bullet__number p">4</span>
              <p className="match-instructions__bullet__copy">
                Once you've chosen your preferred venue you can complete the
                booking
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchInstructions;
